var _circle, _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearchNoresult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 56,
    viewBox: "0 0 53 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22.5,
    fill: "white",
    stroke: "#DFDFDF",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.1213,
    y1: 41,
    x2: 51,
    y2: 53.8787,
    stroke: "#DFDFDF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9999 13.4843C26.9999 12.1123 25.8807 11 24.5 11C23.1193 11 22 12.1123 22 13.4843L22 25.3069C22 26.679 23.1193 27.7912 24.5 27.7912C25.8807 27.7912 26.9999 26.679 26.9999 25.3069L26.9999 13.4843ZM24.5001 35.9745C25.8807 35.9745 27 34.8622 27 33.4902C27 32.1181 25.8807 31.0058 24.5001 31.0058C23.1194 31.0058 22.0001 32.1181 22.0001 33.4902C22.0001 34.8622 23.1194 35.9745 24.5001 35.9745Z",
    fill: "#DFDFDF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchNoresult);
export default __webpack_public_path__ + "static/media/icon__search-noresult.576237ce23c4a373414107a5fe4dda4b.svg";
export { ForwardRef as ReactComponent };